const fields = [
  {
    key: 'day',
    label: 'global.field.date',
    header: 'date',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'totalMoving',
    label: 'report.fields.movingDistance',
    header: 'totalMoving',
    filter: false,
    width: 10,
  },
  // {
  //   key: 'totalAssisted',
  //   label: 'report.fields.assistedDistance',
  //   header: 'total_assisted',
  //   filter: false,
  //   width: 10,
  // },
  {
    key: 'totalHourMovingFormatted',
    label: 'report.fields.movingDuration',
    header: 'totalHourMoving',
    filter: false,
    width: 10,
  },
  // {
  //   key: 'totalHourAssistedFormatted',
  //   label: 'report.fields.assistedDuration',
  //   header: 'total_hour_assisted',
  //   filter: false,
  //   width: 10,
  // },
  {
    key: 'finalOdometer',
    label: 'report.fields.finalOdometer',
    header: 'finalOdometer',
    filter: false,
    width: 10,
  },
  {
    key: 'totalHourTripStopFormatted',
    label: 'report.fields.stopDuration',
    header: 'totalHourTripStop',
    filter: false,
    width: 10,
  },
]
export default fields
